import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Container, Box, Typography, Card, TextField, Button, CircularProgress, Modal } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Avatar from '@mui/material/Avatar';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import LinearProgress from '@mui/material/LinearProgress';
import Pagination from '@mui/material/Pagination';
import { debounce, throttle } from 'lodash';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import '../ServicesMenu/servicesMenu.css';
import { styled } from '@mui/material/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import AddComplaintMessage from './AddComplaintMessage';
import Dialog from '@mui/material/Dialog';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const useStyles = makeStyles((theme) => ({
    // AdminComplaintContainer: {
    //     [theme.breakpoints.down('md')]: {
    //         width: '1000px',
    //     },
    //     [theme.breakpoints.between('md', 'xmd')]: {
    //         width: '1000px',
    //     },
    // },
    // AdminComplaintAutoDateTime: {
    //     width: '320px',
    //     [theme.breakpoints.down('md')]: {
    //         width: '215px',
    //     },
    //     [theme.breakpoints.between('md', 'xmd')]: {
    //         width: '215px',
    //     },
    // },
}));

const AdminComplaint = () => {
    const classes = useStyles();
    const theme = useTheme();
    const [getComplaint, setGetComplaint] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedDate, setSelectedDate] = useState();
    const [complaintModal, setComplaintModal] = useState(false);
    const [selectedComplaintId, setSelectedComplaintId] = useState(null);
    const [MessageLoading, setMessageLoading] = useState(false);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const abortControllerRef = useRef(null);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const userOffset = getUserOffset();

    const handleSearchClick = async () => {
        const currentDate = new Date();

        if (fromDate && new Date(fromDate) > currentDate) {
            toast.error('Please select a from date not later than the current date.');
            return;
        }
        if (toDate && fromDate && new Date(toDate) < new Date(fromDate)) {
            toast.error('Please select a to date later than the start date.');
            return;
        }

        const formattedFromDate = fromDate ? formatDate(fromDate) : null;
        const formattedToDate = toDate ? formatDate(toDate) : null;


        const searchParam = {
            // user_id: selectedUserId,
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };

        await setSelectedDate(searchParam);

        // await AllComplaint(1, searchTerm,searchParam);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const AllComplaint = async (currentPage, searchTerm = '', searchParam = { from_date: '', to_date: '' }) => {
        try {
            setIsLoading(true);
            const res = await LeadService.getComplainsByAdmin(currentPage, searchTerm, searchParam);
            if (res?.data.success) {
                setGetComplaint(res?.data?.complains?.data);
                setCurrentPage(res?.data?.complains?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.complains?.total || 0) / (res?.data?.complains?.per_page || 1)));
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledAllComplaint = useCallback(
        throttle((currentPage, searchTerm, searchParam, signal) => {
            AllComplaint(currentPage, searchTerm, searchParam, signal);
        }, 2000),
        []
    );

    const fetchAllComplaint = useCallback(
        debounce((currentPage, searchTerm, searchParam) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledAllComplaint(currentPage, searchTerm, searchParam, abortController.signal);
        }, 300),
        [throttledAllComplaint]
    );

    useEffect(() => {
        fetchAllComplaint(currentPage, searchTerm, selectedDate);
        // const intervalId = setInterval(() => {
        //     fetchAllComplaint(currentPage, searchTerm, selectedDate);
        // }, 30000); 

        // return () => clearInterval(intervalId);
    }, [currentPage, searchTerm, selectedDate, fetchAllComplaint]);

    const clearState = () => {
        setFromDate('');
        setToDate('');
        setSearchTerm('');
        setSelectedDate('');
        fetchAllComplaint(1, '');
    };

    const handleClear = () => {
        setSearchTerm('');
        setCurrentPage(1);
        fetchAllComplaint(1, searchTerm, selectedDate);
    };

    const HandleChangeStatus = async (id, status, searchTerm, selectedDate) => {
        if (status === 'resolved') {
            return toast.success('This complaint is already resolved!');
        } else {
            setSelectedComplaintId(id);
            setComplaintModal(true);
        }
    };

    const updateComplaintStatus = async (message) => {
        if (message === '') {
            return toast.error('Please fill the message');
        } else {
            try {
                setMessageLoading(true);
                const res = await LeadService.updateComplainStatus(selectedComplaintId, message);
                if (res.data.success) {
                    toast.success(res?.data?.message);
                    fetchAllComplaint(currentPage, searchTerm, selectedDate);
                }
            } catch (error) {
                toast.error(error.message);
            } finally {
                setMessageLoading(false);
                setComplaintModal(false);
            }
        }
    };

    const handleClose = () => {
        setComplaintModal(false);
    };


    return (
        <>
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                <Box className={classes.AdminComplaintContainer}>
                    <div style={{ marginBottom: '15px' }}> {isLoading && <LinearProgress />}</div>

                    <Box>
                        <Typography className="services-animated-text">
                            Promo Message
                        </Typography>
                    </Box>
                    <Box style={{ marginTop: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <Box>
                            <Box>
                                <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                            </Box>
                            <Box>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                        <DesktopDatePicker
                                            className={`${classes.AdminComplaintAutoDateTime} min-width-0`}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    width: {
                                                        xs: "150px",
                                                        sm: "200px",
                                                        md: "250px"
                                                    }
                                                },
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={fromDate}
                                            onChange={(newDate) => setFromDate(newDate)}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Box>
                        </Box>

                        <Box>
                            <div>
                                <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                            </div>
                            <div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                        <DesktopDatePicker
                                            className={`${classes.AdminComplaintAutoDateTime} min-width-0`}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    width: {
                                                        xs: "150px",
                                                        sm: "200px",
                                                        md: "250px"
                                                    },
                                                },
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={toDate}
                                            onChange={(newDate) => setToDate(newDate)}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </div>
                        </Box>
                        <Box style={{ marginTop: '30px' }}>
                            <TextField
                                value={searchTerm}
                                onChange={handleSearchChange}
                                placeholder="Search by name, email"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClear} aria-label="clear search">
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    }, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>
                        <div style={{ marginTop: '25px', display: 'flex', marginBottom: '20px' }}>
                            <Box
                                style={{
                                    width: '56px',
                                    height: '50px',
                                    background: '#336a93',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    marginTop: '6px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                onClick={handleSearchClick}
                            >
                                {isLoading ? (
                                    <CircularProgress sx={{ color: 'white' }} />
                                ) : (
                                    <SearchIcon
                                        style={{
                                            color: 'white',
                                            margin: '12px',
                                            fontSize: '41px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                            </Box>
                            <Button
                                style={{
                                    width: 'auto',
                                    height: '40px',
                                    border: '1px solid gray',
                                    background: '#bababa',
                                    borderRadius: '8px',
                                    fontWeight: 'bold',
                                    marginLeft: '5px',
                                    cursor: 'pointer',
                                    marginTop: '10px',
                                    marginBottom: 'px',
                                    color: 'black',
                                }}
                                sx={{ fontFamily: 'inherit' }}
                                onClick={clearState}
                            >
                                clear
                            </Button>
                        </div>
                    </Box>
                    <Box style={{ marginBottom: '30px' }}>
                        {getComplaint && getComplaint?.length > 0 ? (
                            getComplaint?.map((complain, index) => {
                                const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(complain?.created_at, userOffset);
                                const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : 'No date available';
                                const adjustedDeletedDate = adjustTimeBasedOnOffsetForReceivedData(complain?.user?.deleted_at, userOffset);
                                const formattedDeletedDate = adjustedDeletedDate ? formatDateTime(adjustedDeletedDate) : 'No date available';
                                // Alternate background color based on index
                                const backgroundColor = index % 2 === 0 ? '#f5f5f5' : '#ffffff';
                                return (
                                    <>
                                        <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                                            <Card
                                                sx={{
                                                    padding: {
                                                        xs: "8px",
                                                        sm: "12px",
                                                        md: "20px"
                                                    },
                                                    borderRadius: '22px',
                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                    marginBottom: '12px',
                                                    background: complain?.user?.deleted_at != null ? '#ca8a8ab3' : 'defaultColor',
                                                    color: complain?.user?.deleted_at != null ? '#a53f3f' : 'defaultColor',
                                                    backgroundColor: backgroundColor, // Apply alternating background color
                                                    cursor: 'pointer', // Add hover cursor
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')} // Hover effect
                                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = backgroundColor)} // Restore original color
                                                key={index}
                                            >
                                                <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', gap: '10px' }}>
                                                        <Box>
                                                            <Avatar
                                                                alt={complain?.user?.name}
                                                                src={`https://iconnctapp.com/` + complain?.user?.profile_image}
                                                                sx={{
                                                                    width: {
                                                                        xs: "30px",
                                                                        sm: "60px",
                                                                        md: "100px"
                                                                    },
                                                                    height: {
                                                                        xs: "30px",
                                                                        sm: "60px",
                                                                        md: "100px"
                                                                    },
                                                                    marginRight: {
                                                                        xs: "0px",
                                                                        sm: "20px",
                                                                        md: "30px"
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                        <Box style={{ display: 'grid', gap: '2px' }}>
                                                            <Box>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: {
                                                                            xs: "14px",
                                                                            sm: "18px",
                                                                            md: "22px"
                                                                        },
                                                                        fontWeight: 'bold',
                                                                        color: complain?.status === 'resolved' ? '#2f892fed' : '#006FBF',
                                                                    }}
                                                                >
                                                                    {complain?.user?.name} {complain?.user?.last_name}
                                                                </Typography>
                                                            </Box>

                                                            <Box sx={{
                                                                marginTop: {
                                                                    xs: "6px",
                                                                    sm: "0px",
                                                                    md: "0px"
                                                                }, display: 'flex', gap: '15px'
                                                            }}>
                                                                {complain?.user?.phone && (
                                                                    <div style={{ display: 'flex', gap: '2px' }}>
                                                                        <LocalPhoneIcon sx={{
                                                                            width: {
                                                                                xs: "14px",
                                                                                sm: "16px",
                                                                                md: "18px"
                                                                            },
                                                                        }} />
                                                                        <Typography sx={{
                                                                            fontSize: {
                                                                                xs: "14px",
                                                                                sm: "16px",
                                                                                md: "18px"
                                                                            },
                                                                            whiteSpace: {
                                                                                xs: "nowrap",
                                                                                sm: "nowrap",
                                                                                md: "nowrap"
                                                                            },
                                                                            color: '#858585', fontWeight: 'bold'
                                                                        }}>
                                                                            {complain?.user?.phone}
                                                                        </Typography>
                                                                    </div>
                                                                )}

                                                                <div style={{ display: 'flex', gap: '2px', width: '100%' }}>
                                                                    <EmailIcon sx={{
                                                                        width: {
                                                                            xs: "14px",
                                                                            sm: "16px",
                                                                            md: "18px"
                                                                        },
                                                                    }} />
                                                                    <Typography sx={{
                                                                        fontSize: {
                                                                            xs: "14px",
                                                                            sm: "16px",
                                                                            md: "18px"
                                                                        },
                                                                        wordBreak: 'break-all',
                                                                        color: '#858585', fontWeight: 'bold'
                                                                    }}>
                                                                        {complain?.user?.email}
                                                                    </Typography>
                                                                </div>
                                                            </Box>

                                                            <Box style={{ display: 'flex', gap: '4px' }}>
                                                                <Typography sx={{
                                                                    fontSize: {
                                                                        xs: "12px",
                                                                        sm: "16px",
                                                                        md: "18px"
                                                                    },
                                                                    color: '#858585', fontWeight: 'bold'
                                                                }}>Created on:</Typography>
                                                                <Typography sx={{
                                                                    fontSize: {
                                                                        xs: "12px",
                                                                        sm: "16px",
                                                                        md: "18px"
                                                                    },
                                                                    color: '#858585'
                                                                }}>{formattedDate}</Typography>
                                                            </Box>
                                                            {complain?.resolved_by === null ? null : (
                                                                <Box style={{ display: 'flex', gap: '4px' }}>
                                                                    <Typography sx={{
                                                                        fontSize: {
                                                                            xs: "12px",
                                                                            sm: "16px",
                                                                            md: "18px"
                                                                        },
                                                                        color: '#858585', fontWeight: 'bold'
                                                                    }}>
                                                                        Resolved By:
                                                                    </Typography>
                                                                    <Typography sx={{
                                                                        fontSize: {
                                                                            xs: "12px",
                                                                            sm: "16px",
                                                                            md: "18px"
                                                                        }, color: '#858585'
                                                                    }}>
                                                                        {complain?.resolved_by?.name} {complain?.resolved_by?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                            {complain?.user?.deleted_at === null ? null : (
                                                                <Box style={{ display: 'flex', gap: '4px' }}>
                                                                    <Typography style={{ color: '#858585', fontWeight: 'bold' }}>
                                                                        Deleted User:
                                                                    </Typography>
                                                                    <Typography style={{ color: '#858585' }}>{formattedDeletedDate}</Typography>
                                                                </Box>
                                                            )}
                                                            <Box style={{ marginTop: '1px' }}>
                                                                <Typography style={{ color: '#858585' }}>
                                                                    <span style={{ fontWeight: 'bold', fontFamily: 'inherit' }}>Complain:</span>{' '}
                                                                    {complain?.description}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            sx={{
                                                                padding: {
                                                                    xs: "4px",
                                                                    sm: "6px",
                                                                    md: "8px"
                                                                },
                                                                fontSize: {
                                                                    xs: "12px",
                                                                    sm: "14px",
                                                                    md: "16px"
                                                                },
                                                                right: {
                                                                    xs: "18px",
                                                                    sm: "34px",
                                                                    md: "46px"
                                                                },

                                                                position: "absolute",
                                                                width: 'auto',
                                                                color: complain?.status === 'resolved' ? '#00A300' : '#006FBF',
                                                                backgroundColor: complain?.status === 'resolved' ? '#00A3000D' : '#006FBF0D',
                                                                border: complain?.status === 'resolved' ? '1px solid #00A300' : '1px solid #006FBF',
                                                                borderRadius: '22px',
                                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                fontWeight: 'bold',
                                                            }}
                                                            onClick={() =>
                                                                HandleChangeStatus(complain?.id, complain?.status, searchTerm, selectedDate)
                                                            }
                                                            startIcon={<FiberManualRecordIcon />}
                                                        >
                                                            {complain?.status}
                                                        </Button>
                                                    </div>
                                                </Box>
                                            </Card>
                                        </ScrollAnimation>
                                    </>
                                );
                            })
                        ) : (
                            <Card style={{ padding: '20px', borderRadius: '10px', marginBottom: '12px' }}>
                                <Typography style={{ fontSize: '18px', color: '#858585' }}>No data found</Typography>
                            </Card>
                        )}
                    </Box>
                    <Box style={{ marginTop: '70px' }}>
                        <Pagination
                            count={totalPages}
                            color="primary"
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                        />
                    </Box>
                </Box>
            </ThemeProvider>

            <AddComplaintMessage
                handleClose={handleClose}
                updateComplaintStatus={updateComplaintStatus}
                MessageLoading={MessageLoading}
                complaintModal={complaintModal}
            />

            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />

        </>
    );
};
export default AdminComplaint;
